export const copyOnClick = (value) => {
    navigator.clipboard.writeText(value);
};